import Fuse from 'fuse.js';

import csvData1 from 'bundle-text:./products1.csv';
import csvData2 from 'bundle-text:./products2.csv';
import csvData3 from 'bundle-text:./products3.csv';
import csvData4 from 'bundle-text:./products4.csv';
import csvData7 from 'bundle-text:./products7.csv';
import { CSV } from './csv';

let params = (new URL(window.location.href)).searchParams;
let feed = params.get("feed") || localStorage.getItem('feed') || '1';
localStorage.setItem('feed', feed);
let csvData = {
    '1': csvData1,
    '2': csvData2,
    '3': csvData3,
    '4': csvData4,
    '7': csvData7,
}[feed];

export function parseEmbeddedProducts(): Product[] {
    const productsList: Product[] = CSV.csvToObject(csvData, undefined, (feed == '1') ? ';' : ',').map((product: any) => { // exclude the feed 3, 4, 7, 2 because it has a different structure and is not working well with the current parsing function
        return {
            sku: product.ITEM_NO.toString(),
            image: product.PICTURE_URL,
            name: product.ITEM_NAME,
            description: product.ITEM_DESCRIPTION,
            price: parseFloat(product.PRICE.toString()),
            category: [
                product.SUPPLIER_CATEGORY?.replace('"\r', '').replace('"', ''),
                product.ItemMainGroup_nb,
                product.ItemCategoryGroup_nb,
                product.ItemFamilyGroup_nb,
            ].filter(Boolean).join('/'),
            unit: 'EA',
            unspsc: product.UNSPSC?.toString(),
            labels: product['eco labels'] ? [product['eco labels']] : [],
            labels2: product['sortiments'] ? [product['sortiments']] : [],
            datasheets: product.datasheets,
            safetysheet: product.safetysheet,
        }
    });
    console.log('productsList', productsList);
    return productsList;
}

export function parseCategories(productsList: Product[]) {
    const categories: { name: string, parent?: string }[] = [];
    for (const product of productsList) {
        if (!product.category) continue;
        const categoriesNames = product.category.split('/');
        let parent: string | undefined = undefined;
        for (const category of categoriesNames) {
            if (!categories.find(it => it.name == category)) {
                categories.push({ name: category, parent });
            }
            parent = category;
        }
    }
    return categories;
}

export interface Product {
    category: string;
    image: string;
    brand: string;
    description: any;
    sku: string;
    name: string;
    price: number;
    stockstatus: string;
    datasheets?: string;
    labels?: string[];
    labels2?: string[];
    safetysheet?: string;
}
export interface CartItem {
    id: string;
    product: Product,
    quantity: number,
    options: any,
};

export class Cart {

    items: CartItem[] = [];
}

export class Model {

    allProducts: Product[] = [];
    allCategories: { name: string, parent?: string }[] = [];

    cartClass = '';
    search: string = '';
    filter: any = {};

    labels: string[] = [];
    labels2: string[] = [];

    products: Product[] = [];
    categories: { name: string, parent?: string }[] = [];

    step: number = 100;
    loading: boolean = true;


    inventory: { [sku: string]: number; } | undefined
    // inventory : { sku: string, stock: number, reservedQty : number, nextDeliveryDate: string , nextDeliveryQty: string}[] = [];
    cart = new Cart();

    role = params.get("role") || localStorage.getItem('role') || 'buyer';
    quotes: any[] = [];

    constructor() {
        if (localStorage.getItem('cart')) {
            this.cart = JSON.parse(localStorage.getItem('cart'));
        }
        localStorage.setItem('role', this.role);
    }

}


export type Action
    = { type: 'add', product: Product, quantity: number, options: any }
    | { type: 'remove', product: Product }
    | { type: 'quantity', id: string, quantity: number }
    | { type: 'products', products: Product[] }
    | { type: 'inventory', data: { [sku: string]: number } }
    // | { type: 'inventory', data: { inventory : { sku: string, stock: number, reservedQty : number, nextDeliveryDate: string , nextDeliveryQty: string}[]} }
    | { type: 'filter', filter: any }
    | { type: 'filter.in', key: string, option: string, value: boolean }
    | { type: 'toggleCategory', category: { name: string, parent?: string } }
    | { type: 'search', value: string }
    | { type: 'filter.clear' }
    | { type: 'labels.selected', labels: string[] }
    | { type: 'labels2.selected', labels: string[] }
    | { type: 'endanimate' }
    | { type: 'clear_cart' }
    | { type: 'quotes', quotes: any[] }
    | { type: 'quote.created', quote: any }
    | { type: 'quote.approve', quote: any }
    | { type: 'quote.reject', quote: any }
    | { type: 'quote.delete', quote: any }
    | { type: 'step.set', step: number }
    | { type: 'loading.set', loading: boolean };

export interface Category {
    name: string;
    parent?: string;
}

let fuse = new Fuse([]);

function setCategory(allCategories: Category[], categories: Category[], category: Category, value: boolean) {
    let subs = allCategories.filter(it => it.parent && it.parent == category.name);
    for (const sub of subs) {
        categories = setCategory(allCategories, categories, sub, value);
    }
    if (value) {
        categories.push(category);
    } else {
        categories = categories.filter(it => it.name != category.name);
    }
    return categories;
}

export function RootReducer(this: void, state: Model, action: Action) {
    switch (action.type) {
        case 'quotes':
            state.quotes = action.quotes;
            break;

        case 'quote.created':
            state.quotes.push(action.quote);
            state.cart.items = [];
            localStorage.setItem('cart', JSON.stringify(state.cart));

            break;
        case 'quote.reject':
            state.quotes.find(it => it.id == action.quote.id).status = 'rejected';
            break;
        case 'quote.delete':
            state.quotes = state.quotes.filter(q => q.id == action.quote.id)
            break;
        case 'inventory':
            state.inventory = action.data;
            break;
        // case 'inventory':
        //     state.inventory = action.data.inventory;
        //     break;
        case 'toggleCategory':
            let value = !state.categories.find(it => it.name == action.category.name);
            state.categories = [...setCategory(state.allCategories, state.categories, action.category, value)];
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'clear_cart':
            state.cart.items = [];
            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'filter.clear':
            state.search = '';
            state.filter = {};
            state.categories = [];
            state.labels = [];
            state.labels2 = [];
            state.products = state.allProducts;
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'labels.selected':
            state.labels = action.labels;
            state.products = labelsAndSortimentsSearch(state);
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'labels2.selected':
            state.labels2 = action.labels;
            state.products = labelsAndSortimentsSearch(state);
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'search':
            state.search = action.value;
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'add':
            const id = hash([action.product.sku, action.options]);
            const item = state.cart.items.find(it => it.id == id);
            if (item) {
                item.quantity += action.quantity;
            } else {
                state.cart.items.push({ ...action, id });
            }
            state.cartClass = 'animate__animated animate__headShake';

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'quantity':
            // update quantity
            state.cart.items.filter(it => it.id == action.id).forEach(it => it.quantity = action.quantity);
            // remove if quantity is 0
            state.cart.items = state.cart.items.filter(it => it.quantity);

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'products':
            console.log('products', action.products);
            state.allProducts = action.products;
            state.allCategories = parseCategories(state.allProducts);
            state.products = state.allProducts;
            state.categories = [];
            state.step = 100;
            state.loading = false;
            window.scrollTo({ top: 0, behavior: "instant"})
            fuse = new Fuse(state.products, { keys: ['sku', 'name', 'description'], findAllMatches: true, threshold: 0.3 });
            break;
        case 'filter':
            state.filter = action.filter;
            break;
        case 'filter.in':
            state.filter[action.key] = state.filter[action.key] || [];
            if (action.value) {
                state.filter[action.key].push(action.option);
            } else {
                state.filter[action.key] = state.filter[action.key].filter(it => it !== action.option);
            }
            if (state.filter[action.key].length == 0) {
                delete state.filter[action.key];
            }
            state.step = 100;
            window.scrollTo({ top: 0, behavior: "instant"})
            break;
        case 'endanimate':
            state.cartClass = '';
            break;
        case 'step.set':
            state.step = action.step;
            break;
        case 'loading.set':
            state.loading = action.loading;
        default:
            break;
    }
    return { ...state };
}

function labelsAndSortimentsSearch(state: Model) {
    let products = state.allProducts;

    if (state.labels.length) {
        products = products.filter(product => {
            for (const label of state.labels) {
                if (product.labels?.includes(label)) {
                    return true;
                }
            }
            return false;
        });
    }

    if (state.labels2.length) {
        products = products.filter(product => {
            for (const sortiment of state.labels2) {
                if (product.labels2?.includes(sortiment)) {
                    return true;
                }
            }
            return false;
        });
    }

    return products;
}

export function search(state: Model) {

    let products = state.products;
    console.log('search', state);

    if (state.search) {
        products = fuse.search(state.search).map(it => it.item);
    }

    if (state.categories.length) {
        products = products.filter(product => {
            for (const category of state.categories) {
                if (product.category?.split("/").includes(category.name)) {
                    return true;
                }
            }
            return false;
        });
    }

    return products.filter(product => {
        for (const key in state.filter) {
            const value = state.filter[key];
            if (value == undefined) {
                continue;
            } else if (Array.isArray(value)) {
                if (value.includes(product[key])) {
                    continue;
                }
            } else if (value == product[key]) {
                continue;
            }
            return false;
        }
        return true;
    });
}

const hash = (str: any) => {
    if (typeof (str) !== 'string') {
        str = JSON.stringify(str);
    }
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
};


